import React from 'react';
import PropTypes from 'prop-types';

const ResolutionHdPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M28 20.99A3.006 3.006 0 0 1 24.992 24H7.008A3.002 3.002 0 0 1 4 20.99v-9.98A3.006 3.006 0 0 1 7.008 8h17.984A3.002 3.002 0 0 1 28 11.01v9.98zm-7.634-.986c2.508 0 4.419-1.518 4.419-4.002S22.874 12 20.354 12h-3.36v8.004h3.372zm0-2H19v-4h1.366c1.464 0 2.208.756 2.208 1.992 0 1.188-.804 2.008-2.208 2.008zm-6.366-1v3h2v-8h-2v3h-4v-3H8v8h2v-3h4z"
    />
  );
};

ResolutionHdPath.propTypes = {
  fill: PropTypes.string,
};

export default ResolutionHdPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/technology/resolution-hd.jsx